import ResponseHandlerService from "service/ResponseHandlerService";
import _ from "lodash";
import {
  getAccountDetailsRes,
  getAccountsResource,
} from "service/RestResources";
import store from "store";
import { showDialog } from "DialogProvider";
import { getWrappedJSON } from "Utils/Common";
import axios from "axios";
import Constants from "Utils/Constants";
import toastMaker from "Common/toastmaker";
import { getData } from "Utils/Common";
let logger = require("logger");

var service = {};
service.getAccounts = getAccounts;
// service.updateAccounts= updateAccounts;
service.removeAccount = removeAccount;
service.startAddServerDialog = startAddServerDialog;
service.openAccountDetails = openAccountDetails;
service.updateAccountDetails = updateAccountDetails;
service.goToAccountsPage = goToAccountsPage;
service.goToCreditsPage = goToCreditsPage;
service.updateAccounts = updateAccounts;
service.openAdminPage = openAdminPage;
service.addCredits = addCredits;
service.setMaxThreads = setMaxThreads;
service.addUser = addUser;
service.refreshCreditData = refreshCreditData;
service.openCreditHistoryPage = openCreditHistoryPage;
service.addAccount = addAccount;
service.addServerToAccount = addServerToAccount;
export default service;

const $mdDialog = {};
const state = store.getState();

const mySession = {
  UserData: state.rootScope.user,
};

const $location = {};

function openCreditHistoryPage() {
  var dataparams = {
    datakey: "credithistory",
  };
  getData(dataparams, function(results) {
    ResponseHandlerService.handleResponse(results);
    if (results.ok && results.data.credithistory !== undefined) {
      mySession.UserData.credithistory = results.data.credithistory;
      $location.url("/credhistory");
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  });
}

function refreshCreditData(silentupdate) {
  var dataparams = {
    datakey: "refreshcredits",
  };
  getData(
    dataparams,
    function(results) {
      if (silentupdate) {
      } else {
        ResponseHandlerService.handleResponse(results);
      }
      if (
        results.ok &&
        results.data.refreshcredits !== undefined &&
        results.data.refreshcredits.usercredits !== undefined
      ) {
        mySession.UserData.usercredits =
          results.data.refreshcredits.usercredits;
      }
      if (silentupdate) {
      } else {
        store.dispatch({ type: "ISLOADING", payload: false });
      }
    },
    silentupdate
  );
}

function addUser(dataparams) {
  if (dataparams === undefined) {
    return;
  }
  // alert(JSON.stringify(dataparams));
  dataparams.datakey = "adduser";
  getData(dataparams, function(results) {
    ResponseHandlerService.handleResponse(results);
    if (results.ok && results.data.adduser !== undefined) {
      alert(
        "Added User:" + dataparams.username + " Pass:" + dataparams.password
      );
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  });
}

function setMaxThreads(dataparams) {
  if (dataparams === undefined) {
    return;
  }
  dataparams.datakey = "setmaxthreads";
  getData(dataparams, function(results) {
    ResponseHandlerService.handleResponse(results);
    if (results.ok) {
      alert("Done.");
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  });
}

function addCredits(dataparams) {
  if (dataparams === undefined) {
    return;
  }
  dataparams.datakey = "addcredits";
  // alert(JSON.stringify(dataparams));
  getData(dataparams, function(results) {
    ResponseHandlerService.handleResponse(results);
    if (results.ok && results.data.addcredits !== undefined) {
      alert(
        "Added credits for user, new total is:" +
          results.data.addcredits.usercredits
      );
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  });
}

function openAdminPage() {
  if (mySession.UserData.roles["isAdmin"]) {
    var isAdmin = true;
  } else {
    var isAdmin = false;
  }
  var dataparams = {
    datakey: "adminpage",
  };
  getData(dataparams, function(results) {
    ResponseHandlerService.handleResponse(results);
    if (results.ok && results.data.adminpage !== undefined) {
      if (mySession.UserData.adminpage === undefined) {
        mySession.UserData.adminpage = results.data.adminpage;
      } else {
        _.merge(results.data.adminpage, mySession.UserData.adminpage);
      }
      // alert(JSON.stringify(mySession.UserData.adminpage));
      if (mySession.UserData.adminpage !== undefined) {
        if (isAdmin !== undefined && isAdmin === true) {
          $location.url("/adminpage");
        }
      } else {
        alert("Issue loading data");
      }
    }
    store.dispatch({ type: "ISLOADING", payload: false });
  });
}

function openAccountDetails(row, server) {
  var sendJSON = {
    account: row,
    server: server,
  };
  mySession.accountdetailrow = sendJSON;

  // alert("$sessionStorage.accountdetailrow:"+JSON.stringify($sessionStorage.accountdetailrow));
  updateAccountDetails(false, function() {
    $location.url("/accountdetail");
  });
}

function updateAccountDetails(forceload, successcallback) {
  store.dispatch({ type: "ISLOADING", payload: true });
  // alert("updateAccountDetails:accountdetailrow"+JSON.stringify($sessionStorage.accountdetailrow));
  mySession.accountdetailrow.forceload = forceload;
  var result = getAccountDetailsRes.saveAndGetObject(
    getWrappedJSON(mySession.accountdetailrow),
    function(allSearchResults) {
      // alert("getAccounts"+JSON.stringify(allSearchResults));
      ResponseHandlerService.handleResponse(allSearchResults);
      if (allSearchResults.ok === true) {
        _.merge(
          allSearchResults.data,
          mySession.AccountDetailData.accountdetail
        );
        if (successcallback !== undefined) {
          successcallback();
        }
        // AccountDetailData.accountDetail={playerservername:'Pikapikaamine'};
        // alert("updateAccountDetails:success:"+JSON.stringify(AccountDetailData.accountdetail)+JSON.stringify(allSearchResults.data));
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    },
    function(error) {
      $location.url("/error");
      store.dispatch({ type: "ISLOADING", payload: false });
    }
  );
}

function goToAccountsPage() {
  store.dispatch({ type: "ISLOADING", payload: true });
  updateAccounts(function() {
    $location.url("/accounts");
    store.dispatch({ type: "ISLOADING", payload: false });
  });
}

function goToCreditsPage() {
  store.dispatch({ type: "ISLOADING", payload: true });
  $location.url("/credits");
}

function getAccounts() {
  updateAccounts();
  return mySession.UserData.accounts;
}

function startAddServerDialog(account) {
  $mdDialog
    .show({
      controller: DialogController,
      templateUrl: "fn/accounts/AddServerPopup.jsp",
      parent: document.body,
      // targetEvent: ev,
      clickOutsideToClose: true,
      fullscreen: false,
      // Only for -xs, -sm breakpoints.
    })
    .then(function(answer) {}, function() {});

  function DialogController($scope, $mdDialog) {
    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.addServer = function() {
      // alert("Called add server");
      addServerToAccount(account, $scope.server, $scope);
      // alert("Called add server");
      // $scope.cancel();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }
}

function updateAccounts(callback) {
  store.dispatch({ type: "ISLOADING", payload: true });
  var result = getAccountsResource.saveAndGetObject(
    getWrappedJSON({}),
    function(allSearchResults) {
      // alert("getAccounts"+JSON.stringify(allSearchResults));
      ResponseHandlerService.handleResponse(allSearchResults);
      if (allSearchResults.ok === true) {
        _.merge(allSearchResults.data, mySession.UserData.accounts);
        // alert("after search:
        // "+JSON.stringify(UserData.accounts));
      }
      if (callback !== undefined) {
        callback();
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    },
    function(error) {
      $location.url("/error");
      store.dispatch({ type: "ISLOADING", payload: false });
    }
  );
  // alert("result:"+JSON.stringify(result));
}

function addAccount(email, password, alias) {
  store.dispatch({ type: "ISLOADING", payload: true });
  var dataparams = getWrappedJSON({
    email: email,
    password: password,
    alias: alias,
  });
  return axios
    .post(Constants.addaccountApiPath, dataparams)
    .then((response) => {
      logger.log("add account response", response.data);
      const { data, ok } = response.data;
      if (ok === true) {
        store.dispatch({ type: "SETACCOUNTS", payload: data });
      } else {
        console.error("catght here 01", response.data);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
      showDialog(null);
    })
    .catch((error) => {
      if (error.response) {
        toastMaker.makeToast(error.response.data.message, {
          variant: "error",
        });
      } else {
        console.error(error, error.response);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    });
}

function removeAccount(email) {
  store.dispatch({ type: "ISLOADING", payload: true });
  var dataparams = getWrappedJSON({
    email: email,
  });
  return axios
    .post(Constants.removeaccountApiPath, dataparams)
    .then((response) => {
      logger.log("add account response", response.data);
      const { data, ok } = response.data;
      if (ok === true) {
        store.dispatch({ type: "SETACCOUNTS", payload: data });
      } else {
        console.error("catght here 03", response.data);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    })
    .catch((error) => {
      if (error.response) {
        toastMaker.makeToast(error.response.data.message, {
          variant: "error",
        });
      } else {
        console.error(error, error.response);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    });
}

function addServerToAccount({ email }, server) {
  store.dispatch({ type: "ISLOADING", payload: true });
  var dataparams = getWrappedJSON({
    email,
    server,
  });
  return axios
    .post(Constants.addservertoaccountApiPath, dataparams)
    .then((response) => {
      logger.log("addservertoaccount response", response.data);
      const { data, ok } = response.data;
      if (ok === true) {
        const accounts = [...store.getState().rootScope.accounts];
        accounts.forEach((account) => {
          if (account.email === email) {
            account.servers = data;
          }
        });
        store.dispatch({ type: "SETACCOUNTS", payload: accounts });
      } else {
        console.error("catght here 03", response.data);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
      showDialog(null);
    })
    .catch((error) => {
      if (error.response) {
        toastMaker.makeToast(error.response.data.message, {
          variant: "error",
        });
      } else {
        console.error(error, error.response);
      }
      store.dispatch({ type: "ISLOADING", payload: false });
    });
}
